module.exports = __webpack_public_path__ + "img/zt2.ca5d7d0.png";